var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deluxe-input-manager-base"},[_c(_vm.targetComponent,{tag:"component",attrs:{"enctype":"multipart/form-data","method":"post","items-id":_vm.itemsId,"input-param":_vm.inputParam,"action":_vm.action}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b5822e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/deluxe/DeluxeInputManager.vue
// module id = null
// module chunks = 